package models

import kotlinx.serialization.Serializable

@Serializable
data class PlacementCatModel(
    val id: Int,
    val category: String,
    val ad: String
)
